import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import {
  Tabs,
  Tab,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Link,
  Typography,
  IconButton,
  TextField,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
// import SaveIcon from "@mui/icons-material/Save";
import SaveIcon from "../../assets/images/SaveIcon.png";
import "./MainPage.scss";
import {
  CreateStakemap,
  GetStakemapDetail,
  UpdateStakemap,
  UpdateStakemapAccessed,
} from "../../service/StakemapService";
import { PreferencesContext } from "../../PreferenceContext";
import { AlertType } from "../../shared/AlertType";
import { GetStakeList } from "../../service/StakeService";
import ListPage from "../List/ListPage";
import OrgPage from "../OrgView/OrgPage";
import LinkIcon from "@mui/icons-material/Link";
import ShareProfile from "../../assets/images/shareprofile.png";
import copyicon from "../../assets/images/copyicon.png";
import SendIcon from "../../assets/images/SendIcon.png";
import CloseIcon from "../../assets/images/closeIcon.png";
import MapList from "../MapPage/MapList";
import { Background } from "reactflow";
import CustomTooltip from "../CustomTooltip";
import HelpIcon from "../../assets/images/question.png";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";

const MainPage: React.FC = () => {
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  const [tabValue, setTabValue] = useState(1);

  const [title, setTitle] = useState("Untitled - click here to change");
  const navigate = useNavigate();
  // const { token } = useParams();
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };
  // const token = userContext?.token;
  const { token: tokenFromParams } = useParams();
  const token = tokenFromParams || userContext?.token;
  const urlToken = tokenFromParams;
  const isOwner = !urlToken || urlToken === userContext?.localToken;

  const [openModal, setOpenModal] = useState(false);
  const [openHelpModal, setOpenHelpModal] = useState(false);
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSave();
    }
  };
  // Trigger save on blur (click away)
  const handleBlur = () => {
    handleSave();
  };
  const handleClickOpen = () => {
    setOpenModal(true);
  };
  const handleClose = () => {
    setOpenModal(false);
  };

  const handleOpenHelp = () => {
    setOpenHelpModal(true);
  };
  const handleCloseHelp = () => {
    setOpenHelpModal(false);
  };

  const shareUrl = `${window.location.origin}/${token}`;
  const handleCopyLink = () => {
    try {
      navigator.clipboard.writeText(shareUrl);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: "Link copied to clipboard!",
        alertType: AlertType.Success,
      });
    } catch (error: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: error.message || "Failed to copy link.",
        alertType: AlertType.Error,
      });
    }
  };
  const fetchData = async () => {
    await fetchStakMapDetail();
  };

  const fetchStakMapDetail = async () => {
    try {
      let response: any;
      let params = new URLSearchParams();
      params.append("token", token || "");
      response = await GetStakemapDetail(params);
      if (response?.data?.data) {
        let result = response?.data?.data;
        setTitle(result?.TITLE || "");
        updateUserContext((prev) => ({
          ...prev,
          UID: result?.UID,
        }));
      }
    } catch (error: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: error.message,
        alertType: AlertType.Error,
      });
    }
    try {
      let data = { token };
      await UpdateStakemapAccessed(data);
    } catch (error: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: error.message,
        alertType: AlertType.Warning,
      });
    }
  };

  const handleSave = async () => {
    try {
      if (!title.trim()) {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: "Title is required",
          alertType: AlertType.Error,
        });
        return;
      }
      // if (!userContext?.userId) {
      //   navigate("/sign-up", { replace: true });
      //   return;
      // }
      let response: any;
      let data = {
        token,
        title,
      };
      let newCtx = { ...userContext };
      if (token) {
        response = await UpdateStakemap(data);
        newCtx = {
          ...newCtx,
          stakemapUserId: userContext?.stakemapUserId,
        };
        if (userContext?.userRole === "ADMIN") {
          newCtx.refreshStakeMapList = Date.now();
        }
      } else {
        response = await CreateStakemap(data);
        if (response && response.data?.stakeMap) {
          newCtx = {
            ...newCtx,
            stakemapUserId: Number(response.data.stakeMap.CREATED_BY),
            token: response.data.stakeMap.LINK,
            localToken: response.data.stakeMap.LINK,
          };
        }
        navigate(`/${response.data.token}`);
      }
      if (response?.message && token) {
        newCtx = {
          ...newCtx,
          isAlert: true,
          alertMessage: response?.message,
          alertType: AlertType.Success,
        };
      }
      updateUserContext(newCtx);
    } catch (error: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: error.message,
        alertType: AlertType.Error,
      });
    }
  };

  useEffect(() => {
    if (token) {
      fetchData();
    }
  }, [token]);

  return (
    <Box
      className="mainpage-wrapper"
      sx={{
        height: "100%",
        flex: 1,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* <Box display="flex" alignItems="center" gap={1}>
        <IconButton color="inherit">
          <NotificationsIcon />
        </IconButton>
      </Box> */}
      <Box
        className="page-tabs-container"
        sx={{
          margin: " 14px 24px 0px 24px",
          height: "60px",
        }}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          className="listpage-tabs"
          sx={{ height: "100%" }}
        >
          <Tab label="List view" className="listpage-tab tab-item" />
          <Tab label="Org View" className="listpage-tab tab-item" />
          {/* <Tab
            label={
              <span className={tabValue === 0 ? "pulse-text" : ""}>
                Org View
              </span>
            }
            className="listpage-tab tab-item"
          /> */}
          {userContext?.userRole === "ADMIN" && (
            <Tab label="Map List" className="listpage-tab tab-item" />
          )}
        </Tabs>
        <Box
          sx={{
            heigth: "36px",
            textAlign: "center",
            flex: 1,
            gap: "10px",
            paddingRight: "53px ",
          }}
        >
          <Typography
            sx={{
              fontWeight: "600",
              textAlign: "center",
              marginBottom: "2px",
              fontSize: "14px",
            }}
          >
            Stakeholder Maps - Free Version
          </Typography>
          <Typography>
            <TextField
              className="listpage-title"
              value={title}
              disabled={!isOwner}
              onChange={(e) => setTitle(e.target.value)}
              onKeyDown={handleKeyDown}
              onBlur={handleBlur}
              placeholder="Untitled Stake"
              variant="standard"
              onFocus={(e) => e.target.select()}
            />
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            height: "100%",
          }}
        >
          {isOwner && (
            <Box
              sx={{ ml: "auto", cursor: "pointer" }}
              onClick={handleOpenHelp}
            >
              <HelpOutlineOutlinedIcon style={{ height: 20, width: 20 }} />
            </Box>
          )}

          <span
            style={{
              height: "36px",
              width: "145px",
              display: "flex",
              justifyContent: "flex-end",
              gap: "18px",
            }}
          >
            {isOwner && (
              <Button
                variant="text"
                onClick={() => {
                  if ((userContext?.userId ?? 0) > 0) {
                    handleSave();
                  } else {
                    navigate("/sign-up");
                  }
                }}
                startIcon={
                  <img
                    src={SaveIcon}
                    style={{
                      width: 16,
                      height: 16,
                      alignItems: "center",
                    }}
                  />
                }
                sx={{
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  padding: "0 !important",
                  textTransform: "none",
                  fontWeight: 500,
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                <span className="save-item-button">Save</span>
              </Button>
            )}
            {isOwner && (
              <>
                {(userContext?.userId ?? 0) > 0 ? (
                  <Button
                    variant="text"
                    onClick={handleClickOpen}
                    startIcon={
                      <img
                        src={SendIcon}
                        style={{
                          width: 16,
                          height: 16,
                          alignItems: "center",
                        }}
                      />
                    }
                    sx={{
                      backgroundColor: "transparent",
                      boxShadow: "none",
                      padding: "1px !important",
                      minWidth: 0,
                      textTransform: "none",
                      fontWeight: 500,
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                    }}
                  >
                    <span className="save-item-button">Share</span>
                  </Button>
                ) : (
                  <CustomTooltip text={"Please save map first"}>
                    <Button
                      variant="text"
                      onClick={() => {
                        // handleClickOpen();
                      }}
                      startIcon={
                        <img
                          src={SendIcon}
                          style={{
                            width: 16,
                            height: 16,
                            alignItems: "center",
                          }}
                        />
                      }
                      sx={{
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        padding: "1px !important",
                        minWidth: 0,
                        textTransform: "none",
                        fontWeight: 500,
                        "&:hover": {
                          backgroundColor: "transparent",
                        },
                      }}
                    >
                      <span className="save-item-button">Share</span>
                    </Button>
                  </CustomTooltip>
                )}
              </>
            )}
          </span>
        </Box>
      </Box>

      {tabValue === 0 && (
        <Box className="listpage-content">
          <ListPage title={title} setTitle={setTitle} handleSave={handleSave} />
        </Box>
      )}

      {tabValue === 1 && (
        <Box className="listpage-content ">
          <OrgPage title={title} setTitle={setTitle} handleSave={handleSave} />
        </Box>
      )}
      {tabValue === 2 && (
        <Box className="listpage-content ">
          <MapList title={title} setTitle={setTitle} />
        </Box>
      )}
      <Dialog
        open={openModal}
        onClose={handleClose}
        fullWidth={false}
        maxWidth={false}
        PaperProps={{
          sx: {
            borderRadius: "8px",
            textAlign: "center",
            padding: "30px",
            width: "625px",
            height: "400px",
            m: 0,
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "260px",
            gap: "40px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <span
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              height: "160px",
            }}
          >
            <Box
              sx={{
                width: "450px",
                height: "160px",
                marginLeft: "50px",
              }}
            >
              <Box>
                <img
                  src={ShareProfile}
                  alt="Share Profile"
                  style={{ height: 64, width: 64 }}
                />
              </Box>
              <Box
                sx={{
                  width: "100%",
                  height: "75px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                  marginTop: "18px",
                }}
              >
                <span
                  style={{
                    fontWeight: 400,
                    fontSize: 20,
                    textAlign: "center",
                  }}
                >
                  Share your stakeholder map
                </span>

                <span
                  style={{
                    fontWeight: 400,
                    fontSize: "14px",
                    color: "#919191",
                  }}
                >
                  Share with anyone using this link alone. It is unique to your
                  map. Alternatively, take screenshots for your slides.
                </span>
              </Box>
            </Box>
            <IconButton
              onClick={handleClose}
              disableRipple
              disableFocusRipple
              sx={{
                all: "unset",
                padding: "0 !important",
                display: "flex",
                "&:hover": {
                  backgroundColor: "transparent",
                  cursor: "pointer",
                },
              }}
            >
              <img
                src={CloseIcon}
                alt="Close"
                style={{
                  width: 24,
                  height: 24,
                  padding: 0,
                }}
              />
            </IconButton>
          </span>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #ddd",
              borderRadius: "4px",
              height: "52px",
            }}
          >
            <Box
              sx={{
                maxWidth: 530,
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                paddingRight: "4px",
                padding: " 0px 16px ",
              }}
            >
              <Link
                href={shareUrl}
                target="_blank"
                rel="noopener"
                underline="hover"
                color="primary"
                sx={{ fontSize: 14, color: "#606060" }}
              >
                {shareUrl}
              </Link>
            </Box>
            <IconButton
              onClick={handleCopyLink}
              sx={{
                p: "0 !important",
                "--IconButton-hoverBg": "transparent",
                "&:hover": {
                  backgroundColor: "transparent",
                },
                paddingRight: "10px !important",
              }}
            >
              <img
                src={copyicon}
                alt="Copy"
                style={{ height: 20, width: 20 }}
              />
            </IconButton>
          </Box>
        </Box>

        {/* Close Button */}

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            onClick={handleClose}
            sx={{
              backgroundColor: "#4C0808",
              "&:hover": { backgroundColor: "#4C0808" },
              borderRadius: "4px",
              marginTop: "40px",
              width: "90px",
              height: "42px",
              textAlign: "center",
            }}
          >
            Close
          </Button>
        </Box>
      </Dialog>

      <Dialog
        open={openHelpModal}
        onClose={handleCloseHelp}
        fullWidth={false}
        maxWidth={false}
        PaperProps={{
          sx: {
            borderRadius: "8px",
            textAlign: "center",
            padding: "30px",
            width: "625px",
            height: "340px",
            m: 0,
          },
        }}
      >
        <Box
          sx={{
            textAlign: "left",
            fontSize: "16px",
            lineHeight: "24px",
            // marginBottom: "2px",
          }}
        >
          <Typography sx={{ fontWeight: 600, fontSize: "18px", mb: 2 }}>
            Making your map
          </Typography>

          <Typography sx={{ mb: 2 }}>
            1. Add each stakeholder using the green button in the top-left
            corner.
          </Typography>

          <Typography sx={{ mb: 2 }}>
            {/* 2. Drag each stakeholder node onto the map. */}
            2. Connect nodes by drawing lines between them.
          </Typography>

          <Typography sx={{ mb: 2 }}>
            3. Connect nodes by clicking a dot and dragging to another while
            holding down. The bottom dot of one node connects to the top dot of
            another.
          </Typography>

          <Typography sx={{ mb: 2 }}>
            4. Use the List View anytime for a quick way to review and sort
            stakeholders.
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            onClick={handleCloseHelp}
            sx={{
              backgroundColor: "#4C0808",
              "&:hover": { backgroundColor: "#4C0808" },
              borderRadius: "4px",
              marginTop: "30px",
              width: "90px",
              height: "42px",
              textAlign: "center",
            }}
          >
            Close
          </Button>
        </Box>
      </Dialog>
    </Box>
  );
};

export default MainPage;
